import { useState } from "react";

const GENRES = [
    { name: "Pop", color: "#C2410C" },
    { name: "Rock", color: "#0A0A0A" },
    { name: "Indie", color: "#1B4D3E" },
    { name: "Rap & Hip‑Hop", color: "#7C2D12" },
    { name: "R&B", color: "#C2410C" },
    { name: "EDM", color: "#D4A017" },
    { name: "Country", color: "#7C2D12" },
    { name: "Metal", color: "#0A0A0A" },
    { name: "Acoustic", color: "#1B4D3E" },
    { name: "Soul", color: "#C2410C" },
    { name: "Synthwave", color: "#1B4D3E" },
    { name: "Alternative", color: "#0A0A0A" },
    { name: "Singer‑Songwriter", color: "#7C2D12" },
    { name: "Or something completely unique", color: "#D4A017" },
];

export default function Genres() {
    const [hovered, setHovered] = useState(null);

    return (
        <section
            id="genres"
            className="relative px-6 md:px-10 py-16 md:py-24 bg-[#F1E8D5]"
            data-testid="genres-section"
        >
            <div className="max-w-7xl mx-auto">
                <div className="reveal mb-8 md:mb-12">
                    <h2 className="font-display tracking-tighter font-black leading-[0.95] text-5xl md:text-6xl lg:text-7xl text-black">
                        Pick a genre.
                        <br />
                        <span className="bg-[#C2410C] text-white px-3 -rotate-1 inline-block">Or invent your own.</span>
                    </h2>
                </div>

                <div className="flex flex-wrap gap-3 md:gap-4 reveal">
                    {GENRES.map((g, i) => {
                        const isHover = hovered === i;
                        const yellowText = g.color === "#D4A017" ? "text-black" : "text-white";
                        return (
                            <button
                                key={g.name}
                                onMouseEnter={() => setHovered(i)}
                                onMouseLeave={() => setHovered(null)}
                                onClick={() => {
                                    document.getElementById("teachers")?.scrollIntoView({ behavior: "smooth" });
                                }}
                                className={`relative px-5 md:px-7 py-3 md:py-3.5 rounded-full border-2 border-black transition-all duration-200 font-medium text-sm md:text-base ${
                                    isHover
                                        ? `${yellowText} shadow-[3px_3px_0_0_#0A0A0A] -translate-y-0.5`
                                        : "bg-white text-black hover:shadow-[3px_3px_0_0_#0A0A0A]"
                                }`}
                                style={isHover ? { backgroundColor: g.color } : {}}
                                data-testid={`genre-pill-${i}`}
                            >
                                {g.name}
                            </button>
                        );
                    })}
                </div>

                <p className="mt-12 text-stone-700 max-w-xl reveal">
                    Our producers, backed by advanced music production
                    technology, help bring your vision to life &mdash;
                    whatever that sound looks like.
                </p>
            </div>
        </section>
    );
}
